import { DatePipe } from "@angular/common";
import { Component, inject, OnDestroy, OnInit, signal } from "@angular/core";
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { Router, RouterModule } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { FieldsetModule } from "primeng/fieldset";
import { FloatLabelModule } from "primeng/floatlabel";
import { IftaLabelModule } from "primeng/iftalabel";
import { InputTextModule } from "primeng/inputtext";
import { MessageModule } from "primeng/message";
import { TableLazyLoadEvent, TableModule } from "primeng/table";
import { TooltipModule } from "primeng/tooltip";
import { ToastService } from "../../../../common/services/toast.service";
import { DialogService } from "primeng/dynamicdialog";
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from "rxjs";
import { LineItemsService } from "../../services/line-items.service";
import { GetLineItemResponseDto } from "../../dtos/get-line-item.response.dto";

@Component({
  selector: 'app-view-line-items',
  standalone: true,
  imports: [
      TableModule,
      FieldsetModule,
      TooltipModule,
      ButtonModule,
      MessageModule,
      RouterModule,
      DatePipe,
      FloatLabelModule,
      ReactiveFormsModule,
      InputTextModule,
      IftaLabelModule,
      ReactiveFormsModule
  ],
  providers: [DialogService,ToastService,LineItemsService],
  templateUrl: './view-line-items.html'
})
export class ViewLineItems implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private isSearchTriggered = false;

  private router = inject(Router);
  private lineItemsService:LineItemsService = inject(LineItemsService);

  loading = signal<boolean>(false);
  lineItems:Array<GetLineItemResponseDto> = new Array<GetLineItemResponseDto>()
  selectedLineItem!:GetLineItemResponseDto
  first: number = 0;
  rows: number = 10;
  totalRecords = signal<number>(0);
  sortField = 'code';
  sortOrder = 'ASC';
  searchQuery:FormControl = new FormControl();
  toastService = inject(ToastService);


    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();    
    }
    ngOnInit(): void {
        this.searchQuery.valueChanges.pipe(
              debounceTime(300),
              distinctUntilChanged(),
              takeUntil(this.destroy$)
            ).subscribe((value: string) => {
              if (value && value.length >= 3) {
                this.isSearchTriggered = true;
                this.first = 0;
                this.loadLineItems({
                  skip: 0,
                  limit: this.rows,
                  sortField: this.sortField,
                  sortOrder: this.sortOrder
                });
              } else if (!value || value.length === 0) {
                // Reset to show all results when search is cleared
                this.isSearchTriggered = true;
                this.first = 0;
                this.loadLineItems({
                  skip: 0,
                  limit: this.rows,
                  sortField: this.sortField,
                  sortOrder: this.sortOrder
                });
              }
            });
    }
    

  onLazyLoad(event: TableLazyLoadEvent) {
    // Skip if this was triggered by search resetting first
    if (this.isSearchTriggered) {
      this.isSearchTriggered = false;
      return;
    }
    
    // Update stored values for use by search
    this.sortField = event.sortField as string ?? 'code';
    this.sortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
    this.rows = event.rows ?? 10;
    
    this.loadLineItems({ 
      skip: event.first ?? 0,
      limit: this.rows,
      sortField: this.sortField,
      sortOrder: this.sortOrder 
    });
  }
  async loadLineItems({skip,limit,sortField,sortOrder}:{skip:number,limit:number,sortField:string,sortOrder:string}){
    try{
      this.loading.set(true);
      const response = await this.lineItemsService.getLineItems({skip,limit,sortField,sortOrder,searchQuery:this.searchQuery.value});
      this.lineItems = response.data
      this.totalRecords.set(response.total);
    }catch(e){
       this.toastService.show({severity:"error", summary:"Error",detail:"Failed to load line-items, please contact tech-support."}); 
       console.error(e);
    } finally {
      this.loading.set(false);
    }
  }
  goToGradeBook(lineItemId:string,courseCode:string){
      this.router.navigate([`/view-grade-book/${lineItemId}/${courseCode}`])
  }
}